import FileSaver from 'file-saver';

export function downloadDataAsFile(data: string | Blob, filename: string, type?: string): void {
  if (typeof data === 'string' && !type) {
    throw Error('Data needs a type if it is not of type Blob');
  }
  FileSaver.saveAs(data instanceof Blob ? data : new Blob([data], {type}), filename);
}
